import React, { useCallback } from 'react';
import { Modal } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';

import {
  RECORDING_REQUEST_MODAL_STAGE,
  RecordingRequestStageSelector,
  setModalStage,
} from 'features/recording';
import RecordingRequestModalContentRenderer from '../RecordingRequestModalContentRenderer';

export default function RecordingRequestModal() {
  const dispatch = useDispatch();
  const modalStage = useSelector(RecordingRequestStageSelector);
  const isModalOpen = modalStage !== RECORDING_REQUEST_MODAL_STAGE.notOpen;

  const handleClose = useCallback(() => {
    dispatch(setModalStage(RECORDING_REQUEST_MODAL_STAGE.notOpen));
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      size="large"
      unMountOnClose
      onClose={handleClose}
      withoutHeader
    >
      <RecordingRequestModalContentRenderer />
    </Modal>
  );
}
